import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { getJwt, removeJwt, setJwt } from '@jane/shared/auth';
import type { QueryBody } from '@jane/shared/data-access';

type GetJwtQueryBody = QueryBody<string | null | undefined>;

export const getJwtQueryBody = (): GetJwtQueryBody => {
  const jwt = getJwt();

  return {
    queryFn: () => getJwt() ?? null,
    queryKey: ['jwt', jwt],
    staleTime: Infinity,
  };
};

export const useGetJwt = () => useQuery(getJwtQueryBody());

export const useSaveJwt = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (jwt: string | null) => {
      if (jwt) {
        return setJwt(jwt);
      } else {
        return removeJwt();
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['jwt'] });
    },
  });
};
